import { useState } from 'react';
import SearchTwoToneIcon from '@mui/icons-material/SearchTwoTone';
import './MyNominationSearch.css';

export default function MyNominationSearch({nominationList,setFilteredData}) {
  const [filterShow, setFilterShow] = useState(false);   
  const [searchTerm, setSearchTerm] = useState('');  

  const handleFilterShow = (e) =>  {
    setFilterShow(!filterShow)             
  }  

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);    
    let filteredOptions = nominationList.filter((obj) => obj.email.toLowerCase().includes(e.target.value.toLowerCase()));            
    setFilteredData(filteredOptions);
  };

  return <div className='MyNominationSearch'>        
    <SearchTwoToneIcon onClick={handleFilterShow} className='search_icon' />               
    {filterShow && <div className="search_box">                              
        <span className="arrow_up"></span>
        <input type="text" className="search_input" placeholder="Search..." value={searchTerm} onChange={handleSearch} onClick={(e) => e.stopPropagation()} />                  
      </div>}
  </div>
}